import React, { useEffect } from "react";
import price_img_1 from "../assets/Images/pricing_1.svg";
import price_img_2 from "../assets/Images/pricing_2.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link } from "react-router-dom";
const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])
    const personalInfoFields = [
        "Name",
        "Contact information (address, phone number, email)",
        "Date of birth",
        "Medical history and treatment information",
        "Insurance information",
        "Payment information",
    ];
    const dataCollectionFields = [
        "IP address",
        "Browser type",
        "Operating system",
        "Device information",
        "Insurance information",
        "Browsing behavior on our website",
    ];
    const dataUsagePurposes = [
        "Provide and manage healthcare services",
        "Process payments and insurance claims",
        "Communicate with you regarding appointments, treatment, and administrative matters",
        "Comply with legal and regulatory requirements",
        "Improve our services and website",
        "Conduct research and analysis (with anonymized data)",
    ];
    const dataSharingScenarios = [
        "With healthcare providers involved in your care",
        "With insurance companies for billing purposes",
        "With third-party service providers who assist us in our operations (e.g., IT services, billing)",
        "When required by law or to comply with legal processes",
        "To protect the rights, property, or safety of MagnAid Hospitals, our patients, or others",
        "With your consent or at your direction",
    ];
    const userDataRights = [
        "Access your personal information",
        "Request corrections to your personal information",
        "Request the deletion of your personal information, subject to legal and contractual obligations",
        "Object to or restrict the processing of your personal information",
        "Request a copy of your personal information in a portable format"
    ];
    return (
        <>
            <title>
                Privacy Policy | MagnAid Hospitals, Yousufguda Hyderabad
            </title>
            <meta name="description" content="Learn how MagnAid Hospitals collects, uses, and protects your personal data. We value your privacy and ensure your information stays safe and confidential." />
            <div className="w-full flex flex-col justify-center md:pb-20 pb-8 items-center px-2 md:px-0 border-b-[1px]">
                <div className="xl:w-4/5  w-[90%] h-[200px] lg:h-[350px] flex justify-center  flex-col items-center rounded-3xl md:mt-8 mt-4 bg-verylightGreen relative overflow-hidden">
                    <div className="absolute -bottom-8 sm:bottom-0 right-0">
                        <img src={price_img_1} alt="" className="sm:w-auto w-20" />
                    </div>
                    <div className="absolute sm:top-0 sm:left-0 -left-5 -top-6">
                        <img src={price_img_2} alt="" className="sm:w-auto w-20" />
                    </div>
                    <h1 className="lg:text-[58px] md:text-[48px] text-[36px] leading-[1.138em] font-heading text-thickGreen mb-4">
                        Privacy Policy
                    </h1>
                </div>
                <div className="xl:w-4/5  w-[90%]  mt-8">
                    <p className="mb-[24px] text-paraGreen md:text-[20px] text-lg md:px-3 px-0 font-body font-medium leading-[1.667em]  md:text-center text-left">
                        MagnAid Hospitals is committed to protecting the privacy and security
                        of your personal information. This Privacy Policy outlines our
                        practices regarding the collection, use, and disclosure of information
                        we receive from patients, visitors, and users of our services. By
                        accessing our services, you agree to the terms of this policy.
                    </p>
                    <h2 className="md:text-3xl text-2xl font-heading my-3 text-lightGreen">
                        Information We Collect
                    </h2>
                    <div className="sm:px-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            1. Personal Information
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We collect personal information that you provide to us directly,
                            including but not limited to:
                        </p>
                        <ul className="sm:px-2 my-3">
                            {personalInfoFields.map((item, index) => (
                                <li
                                    key={index}
                                    className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body"
                                >
                                    {" "}
                                    <span className="flex-shrink-0 text-orange">
                                        <CheckCircleIcon />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            2. Automatically Collected Information
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3  font-body font-medium leading-[1.667em] ">
                            We may also collect information automatically when you interact with
                            our services, such as:
                        </p>
                        <ul className="px-2 my-3">
                            {dataCollectionFields.map((item, index) => (
                                <li
                                    key={index}
                                    className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body"
                                >
                                    {" "}
                                    <span className="flex-shrink-0 text-orange">
                                        <CheckCircleIcon />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            3. Third-Party Information
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3  px-3 font-body font-medium leading-[1.667em] ">
                            We may receive information about you from third parties, such as
                            insurance companies, healthcare providers, and other entities
                            involved in your care.
                        </p>
                    </div>
                    <h2 className="md:text-3xl text-2xl font-heading  my-3 text-lightGreen">
                        How We Use Your Information
                    </h2>
                    <div className="px-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            1. We use your personal information to:
                        </h3>

                        <ul className="sm:px-2 my-3">
                            {dataUsagePurposes.map((item, index) => (
                                <li
                                    key={index}
                                    className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body"
                                >
                                    {" "}
                                    <span className="flex-shrink-0 text-orange">
                                        <CheckCircleIcon />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="ms:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            2. Sharing Your Information
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We do not sell your personal information. We may share your
                            information in the following circumstances:
                        </p>
                        <ul className="sm:px-2 my-3">
                            {dataSharingScenarios.map((item, index) => (
                                <li
                                    key={index}
                                    className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body"
                                >
                                    {" "}
                                    <span className="flex-shrink-0 text-orange">
                                        <CheckCircleIcon />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="sm:px-3 mb-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            3. Security of Your Information
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We implement appropriate technical and organizational measures to
                            protect your personal information from unauthorized access, use,
                            disclosure, alteration, or destruction. These measures include
                            encryption, access controls, and regular security assessments.
                        </p>
                    </div>
                    <h2 className="md:text-3xl text-2xl font-heading  my-3 text-lightGreen">
                        Your Rights
                    </h2>
                    <div className="sm:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            1. You have the right to
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We do not sell your personal information. We may share your information in the following circumstances:
                        </p>
                        <ul className="px-2 my-3">
                            {userDataRights.map((item, index) => (
                                <li
                                    key={index}
                                    className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body"
                                >
                                    {" "}
                                    <span className="flex-shrink-0 text-orange">
                                        <CheckCircleIcon />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            To exercise these rights, please contact us using the contact information provided below.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            2. Cookies and Tracking Technologies
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            Our website uses cookies and similar technologies to enhance your experience. You can manage your cookie preferences through your browser settings. For more information, please refer to our Cookie Policy.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3 py-3">
                        <h3 className="md:text-2xl text-xl  font-body font-bold text-lightGreen">
                            3. Changes to This Privacy Policy
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on our website and updating the effective date. Your continued use of our services after the changes take effect constitutes your acceptance of the updated policy.
                        </p>
                    </div>
                    <h2 className="md:text-3xl text-2xl font-heading my-3 text-lightGreen">
                        Contact Us
                    </h2>
                    <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                        If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at:
                    </p>
                    <p className="text-lg font-medium font-body text-lightGreen">
                        MagnAid Hospitals Privacy Office
                    </p>
                    <div className="mt-4 flex my-3 flex-col">
                        <p className="sm:text-[18px] text-[16px] text-lightGreen font-body font-bold mb-[12px]">
                            Email address
                        </p>
                        <Link
                            to="mailto:info@magnaid.com"
                            className="text-[22px] text-thickGreen font-body font-medium"
                        >
                            info@magnaid.com
                        </Link>
                        <Link
                            to="mailto:magnaidhospitals@gmail.com"
                            className="text-[22px] text-thickGreen font-body font-medium"
                        >
                            magnaidhospitals@gmail.com
                        </Link>
                    </div>
                    <div className="my-[24px] border-b border-[#c4d6d6]"></div>
                    <div className="mb-10 lg:mb-0 mt-4 flex flex-col">
                        <p className="sm:text-[18px] text-[16px] text-lightGreen font-body font-bold mb-[12px]">
                            Phone number
                        </p>
                        <a
                            href="tel:7993999040"
                            className="text-[22px] text-thickGreen font-body font-medium"
                        >
                            7993 999 040
                        </a>
                        <a
                            href="tel:7993999044"
                            className="text-[22px] text-thickGreen font-body font-medium"
                        >
                            7993 999 044
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
